import EmailLogsService from "@/api/services/emailLogs";
import { toCamelCase } from "@/utils/utils";

const initialState = {
  emailLogs: [],
  totalPages: null,
  totalCount: null,
  selectedFilters: {
    status: [],
  },
  keywords: "",
};

export default {
  namespaced: true,

  state: initialState,

  getters: {
    emailLogs: (state) => {
      return state.emailLogs;
    },

    totalPages: (state) => {
      return state.totalPages;
    },

    totalCount: (state) => {
      return state.totalCount;
    },
  },

  mutations: {
    setEmailLogs(state, { emailLogs, totalCount, totalPages }) {
      state.emailLogs = emailLogs;
      state.totalCount = totalCount;
      state.totalPages = totalPages;
    },

    setFilter(state, { filterName, filterOptions }) {
      state.selectedFilters[filterName] = filterOptions;
    },

    setKeywords(state, keywords) {
      state.keywords = keywords;
    },
  },

  actions: {
    async fetchIndex({ commit }, { page, keywords, status }) {
      const response = await EmailLogsService.fetchIndex({
        page,
        keywords,
        status,
      });

      if (!response?.success) return response;

      const responseData = toCamelCase(response.data);

      commit("setEmailLogs", {
        emailLogs: responseData.emailLogs,
        totalCount: responseData.page.totalCount,
        totalPages: responseData.page.totalPages,
      });

      return response;
    },

    updateSearch({ commit }, { searchString }) {
      commit("setKeywords", searchString);
    },

    updateFilter({ commit }, { filterName, filterOptions }) {
      commit("setFilter", { filterName, filterOptions });
    },
  },
};
